export default "__VITE_ASSET__63826412__"